import PersonalProfile from "features/people/blocks/PersonalProfile";
import React from "react";
import { useParams } from "react-router-dom";

import PageLayout from "../../common/PageLayout";

const PersonPage: React.FC = () => {
  const { personId } = useParams<{ personId: string }>();

  return (
    <PageLayout>
      <PersonalProfile id={Number(personId)} />
    </PageLayout>
  );
};

export default PersonPage;
